import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Modal/Components/BaseModal/BaseModal';
import CaseTakeOver from './CaseTakeOver';

interface Props extends BaseModalProps {
	caseId: string;
}

const CaseTakeOverModal: React.FC<Props> = props => {
	return (
		<BaseModal title='component.caseTakeOver.modalTitle' {...props}>
			<CaseTakeOver caseId={props.caseId} />
		</BaseModal>
	);
};

export default CaseTakeOverModal;
